export default "<app-list-demandes \r\n[typeService]=\"typeService\"\r\n[groupeExtension]=\"groupeExtension\">\r\n</app-list-demandes>";